import { defineType } from "sanity";
import {
  airNonAirFilter,
  locationFilter,
  filterableMultilingualText,
  filterableMultilingualString
} from "../base";

export default defineType({
  name: "heroSlideContent",
  type: "object",
  title: "Slide content",
  fields: [
    {
      name: "image",
      type: "imageWithAlt",
      options: {
        hotspot: true,
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "title",
      title: "Title",
      type: "array",
      of: [{ type: filterableMultilingualString.name }]
    },
    {
      name: "content",
      title: "Content",
      type: "array",
      of: [{ type: filterableMultilingualText.name }]
    },
    {
      type: "ctaButtons",
      name: "ctaButtons",
      title: "CTA Buttons",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "locationFilters",
      title: "Location Filters",
      type: "array",
      of: [
        {
          type: locationFilter.name
        },
        {
          type: airNonAirFilter.name
        }
      ]
    },
    {
      name: "customKey",
      title: "Custom Key",
      description: "Used to identify the slide in the code",
      type: "string"
    }
  ],
  preview: {
    select: {
      imageUrl: "image",
      title: "title"
    },
    prepare({ title, imageUrl }) {
      return {
        //@ts-ignore
        title: filterableMultilingualString.toString((title || [])[0]),
        media: imageUrl
      };
    }
  }
});
